export default [
  {
    "x": 50.526447,
    "y": 32.0495442,
    "angle": 2.6021310697560085,
    "lengthA": 4.801842915372255,
    "lengthB": 7.127246960193576
  },
  {
    "x": 83.0844491,
    "y": 28.388462,
    "angle": -2.807002982935387,
    "lengthA": 10.260921636850982,
    "lengthB": 10.260921764143651
  },
  {
    "x": 96.5878065,
    "y": 36.3314781,
    "angle": -2.574839815804163,
    "lengthA": 6.503868859477428,
    "lengthB": 6.503869166261611
  },
  {
    "x": 112.290731,
    "y": 40.575133,
    "angle": -2.674851881261198,
    "lengthA": 10.149161248015968,
    "lengthB": 10.149161293013773
  },
  {
    "x": 129.778908,
    "y": 62.696936,
    "angle": -1.270099856628183,
    "lengthA": 8.820634416670773,
    "lengthB": 8.82063412048533
  },
  {
    "x": 123.654265,
    "y": 78.5606823,
    "angle": -2.078566813146584,
    "lengthA": 7.223121302155528,
    "lengthB": 7.223121214772467
  },
  {
    "x": 117.661471,
    "y": 94.8623892,
    "angle": -0.284654404425033,
    "lengthA": 7.631139499932979,
    "lengthB": 7.631139528015573
  },
  {
    "x": 93.2764429,
    "y": 89.4212914,
    "angle": 1.2043886040326823,
    "lengthA": 11.632789065340665,
    "lengthB": 11.63278953215086
  },
  {
    "x": 63.3148302,
    "y": 84.6970221,
    "angle": 0.7642835028985336,
    "lengthA": 8.867287537074771,
    "lengthB": 8.867287467872782
  },
  {
    "x": 54.8126341,
    "y": 70.8240666,
    "angle": 0,
    "lengthA": 3.591848200000001,
    "lengthB": 3.591848199999994
  },
  {
    "x": 36.3759686,
    "y": 65.5202955,
    "angle": 1.3742830242595674,
    "lengthA": 9.666373711917089,
    "lengthB": 9.666373692392002
  },
  {
    "x": 44.6304143,
    "y": 44.8985359,
    "angle": 3.141592653589793,
    "lengthA": 4.5392538999999985,
    "lengthB": 4.539254
  },
  {
    "x": 46.6326198,
    "y": 40.575133,
    "angle": 0.8819792353334744,
    "lengthA": 3.1499820108857257,
    "lengthB": 3.149982010885731
  }
]
